// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface IVehicleIdentificationType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
}

export class VehicleIdentificationType implements IVehicleIdentificationType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns VIN VehicleIdentificationType
	**/
    get VIN(): IVehicleIdentificationType {
        return this.FromId(1);
    }
    /**
		Returns Vehicle Number VehicleIdentificationType
	**/
    get VehicleNumber(): IVehicleIdentificationType {
        return this.FromId(2);
    }
    /**
		Returns Title Number VehicleIdentificationType
	**/
    get TitleNumber(): IVehicleIdentificationType {
        return this.FromId(3);
    }
    /**
		Returns Plate Number VehicleIdentificationType
	**/
    get PlateNumber(): IVehicleIdentificationType {
        return this.FromId(4);
    }
    /**
		Returns Permit Number VehicleIdentificationType
	**/
    get PermitNumber(): IVehicleIdentificationType {
        return this.FromId(5);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, value: 'VIN', displayValue: 'VIN', description: 'VIN', sortOrder: 5, active: true });
        this._dictionary.add('2', { id: 2, value: 'VehicleNumber', displayValue: 'Vehicle Number', description: 'Vehicle Number', sortOrder: 10, active: true });
        this._dictionary.add('3', { id: 3, value: 'TitleNumber', displayValue: 'Title Number', description: 'Title Number', sortOrder: 15, active: true });
        this._dictionary.add('4', { id: 4, value: 'PlateNumber', displayValue: 'Plate Number', description: 'Plate Number', sortOrder: 20, active: true });
        this._dictionary.add('5', { id: 5, value: 'PermitNumber', displayValue: 'Permit Number', description: 'Permit Number', sortOrder: 25, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): IVehicleIdentificationType {
        return this._dictionary[id];
    }

    public FromValue(value: string): IVehicleIdentificationType {
        var match = this._dictionary.getValues().filter(d => d.value == value);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): IVehicleIdentificationType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): IVehicleIdentificationType[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): IVehicleIdentificationType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        var get = (obj, path) => {
                if (path) {
                    path = path.split('.');

                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }

                    return obj[path[len]];
                }
                return obj;
            },
            prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
